import { NbThemeService } from '@nebular/theme';
import { Component, OnInit } from "@angular/core";
import { AnalyticsService } from "./@core/utils/analytics.service";
import { LocalStorageService } from "./components/services/localstorage/localstorage.component";
import { CookieService } from 'ngx-cookie-service';
import { environment } from "../environments/environment";
import { Router } from "@angular/router";

@Component({
  selector: "ngx-app",
  template: "<router-outlet></router-outlet>",
})
export class AppComponent implements OnInit {
  tema: string;
  user;
  constructor(
    private analytics: AnalyticsService,
    private localstg: LocalStorageService,
    private cookieService: CookieService,
    private themeService: NbThemeService,
    private router: Router
  ) { }

  ngOnInit(): void {
    console.log(environment.version)
    console.log(window.caches)
    if (!sessionStorage.getItem('current_version') || sessionStorage.getItem('current_version') !== environment.version) {

      if ('caches' in window) {
        caches.keys().then(cacheNames => {
          cacheNames.forEach(function (cacheName) {
            caches.delete(cacheName);
          });
        });
      }

      this.cookieService.deleteAll();
      localStorage.clear();
      sessionStorage.clear();
      caches
      sessionStorage.setItem('current_version', environment.version);
      console.log("Cambio de version ejecutada... " + environment.version);
      this.router.navigate(['/login']);
    }

    this.analytics.trackPageViews();
    this.themeService.changeTheme('compartamos');
    const cuser = {
      perms: {}
    };

    this.localstg.storeUserOnLocalStorage(cuser)
  }
}
